module.exports = __webpack_public_path__ + "media/images/hannukah-aa7a7aaa8cfd9de98e78679d308a1962.png";